<template>
  <v-card
    :elevation="raised ? '3' : '0'"
    outlined
    tile
  >
    <v-toolbar
      flat
      :height='30'
      color='blue-grey lighten-5'
      class='black--text text--lighten-1 font-weight-thin text-uppercase'
    >
      {{ title }}
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'wc-mini-card',
  props: {
    title: {
      required: true
    },
    raised: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
